import React from "react";
import styles from "./ListCard.module.scss";

export interface ListCardProps {
  id: string;
  title: string;
}

class ListCard extends React.Component<ListCardProps> {

  render() {
    return (
      <div className={styles.FormContainer}>
        <label id={"lbl" + this.props.id} className={styles.Title}>{this.props.title}</label>
        <ul className={styles.ListCard}>
          {this.props.children &&
          <div id={this.props.id} className={styles.Content}>
            {this.props.children}
          </div>}
        </ul>
      </div>
    );
  }
}

export default ListCard;
